/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountCodeValidation,
    AccountCodeValidationFromJSON,
    AccountCodeValidationFromJSONTyped,
    AccountCodeValidationToJSON,
    CardPoolSettingsValidation,
    CardPoolSettingsValidationFromJSON,
    CardPoolSettingsValidationFromJSONTyped,
    CardPoolSettingsValidationToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsCreateRequestValidationData
 */
export interface VccCredentialsCreateRequestValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    accountCodes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    cardPoolSettings?: ValidationMessage;
    /**
     * 
     * @type {Array<AccountCodeValidation>}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    readonly accountCodesRestrictions?: Array<AccountCodeValidation> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    agentId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    apiKey?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    username?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    organisationId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    merchantId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    bankId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    companyId?: ValidationMessage;
    /**
     * 
     * @type {Array<CardPoolSettingsValidation>}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    readonly cardPoolSettingsRestrictions?: Array<CardPoolSettingsValidation> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    bookerId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    cardSupplier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    clientId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    consumer?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    email?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    password?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    server?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    url?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    uniqueness?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    addressLine1?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    addressLine2?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    city?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    country?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsCreateRequestValidationData
     */
    zip?: ValidationMessage;
}

export function VccCredentialsCreateRequestValidationDataFromJSON(json: any): VccCredentialsCreateRequestValidationData {
    return VccCredentialsCreateRequestValidationDataFromJSONTyped(json, false);
}

export function VccCredentialsCreateRequestValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsCreateRequestValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountCodes': !exists(json, 'accountCodes') ? undefined : ValidationMessageFromJSON(json['accountCodes']),
        'cardPoolSettings': !exists(json, 'cardPoolSettings') ? undefined : ValidationMessageFromJSON(json['cardPoolSettings']),
        'accountCodesRestrictions': !exists(json, 'accountCodesRestrictions') ? undefined : (json['accountCodesRestrictions'] === null ? null : (json['accountCodesRestrictions'] as Array<any>).map(AccountCodeValidationFromJSON)),
        'agentId': !exists(json, 'agentId') ? undefined : ValidationMessageFromJSON(json['agentId']),
        'apiKey': !exists(json, 'apiKey') ? undefined : ValidationMessageFromJSON(json['apiKey']),
        'username': !exists(json, 'username') ? undefined : ValidationMessageFromJSON(json['username']),
        'organisationId': !exists(json, 'organisationId') ? undefined : ValidationMessageFromJSON(json['organisationId']),
        'merchantId': !exists(json, 'merchantId') ? undefined : ValidationMessageFromJSON(json['merchantId']),
        'bankId': !exists(json, 'bankId') ? undefined : ValidationMessageFromJSON(json['bankId']),
        'companyId': !exists(json, 'companyId') ? undefined : ValidationMessageFromJSON(json['companyId']),
        'cardPoolSettingsRestrictions': !exists(json, 'cardPoolSettingsRestrictions') ? undefined : (json['cardPoolSettingsRestrictions'] === null ? null : (json['cardPoolSettingsRestrictions'] as Array<any>).map(CardPoolSettingsValidationFromJSON)),
        'bookerId': !exists(json, 'bookerId') ? undefined : ValidationMessageFromJSON(json['bookerId']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'cardSupplier': !exists(json, 'cardSupplier') ? undefined : ValidationMessageFromJSON(json['cardSupplier']),
        'clientId': !exists(json, 'clientId') ? undefined : ValidationMessageFromJSON(json['clientId']),
        'consumer': !exists(json, 'consumer') ? undefined : ValidationMessageFromJSON(json['consumer']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'email': !exists(json, 'email') ? undefined : ValidationMessageFromJSON(json['email']),
        'password': !exists(json, 'password') ? undefined : ValidationMessageFromJSON(json['password']),
        'server': !exists(json, 'server') ? undefined : ValidationMessageFromJSON(json['server']),
        'url': !exists(json, 'url') ? undefined : ValidationMessageFromJSON(json['url']),
        'uniqueness': !exists(json, 'uniqueness') ? undefined : ValidationMessageFromJSON(json['uniqueness']),
        'addressLine1': !exists(json, 'addressLine1') ? undefined : ValidationMessageFromJSON(json['addressLine1']),
        'addressLine2': !exists(json, 'addressLine2') ? undefined : ValidationMessageFromJSON(json['addressLine2']),
        'city': !exists(json, 'city') ? undefined : ValidationMessageFromJSON(json['city']),
        'country': !exists(json, 'country') ? undefined : ValidationMessageFromJSON(json['country']),
        'zip': !exists(json, 'zip') ? undefined : ValidationMessageFromJSON(json['zip']),
    };
}

export function VccCredentialsCreateRequestValidationDataToJSON(value?: VccCredentialsCreateRequestValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountCodes': ValidationMessageToJSON(value.accountCodes),
        'cardPoolSettings': ValidationMessageToJSON(value.cardPoolSettings),
        'agentId': ValidationMessageToJSON(value.agentId),
        'apiKey': ValidationMessageToJSON(value.apiKey),
        'username': ValidationMessageToJSON(value.username),
        'organisationId': ValidationMessageToJSON(value.organisationId),
        'merchantId': ValidationMessageToJSON(value.merchantId),
        'bankId': ValidationMessageToJSON(value.bankId),
        'companyId': ValidationMessageToJSON(value.companyId),
        'bookerId': ValidationMessageToJSON(value.bookerId),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'cardSupplier': ValidationMessageToJSON(value.cardSupplier),
        'clientId': ValidationMessageToJSON(value.clientId),
        'consumer': ValidationMessageToJSON(value.consumer),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'email': ValidationMessageToJSON(value.email),
        'password': ValidationMessageToJSON(value.password),
        'server': ValidationMessageToJSON(value.server),
        'url': ValidationMessageToJSON(value.url),
        'uniqueness': ValidationMessageToJSON(value.uniqueness),
        'addressLine1': ValidationMessageToJSON(value.addressLine1),
        'addressLine2': ValidationMessageToJSON(value.addressLine2),
        'city': ValidationMessageToJSON(value.city),
        'country': ValidationMessageToJSON(value.country),
        'zip': ValidationMessageToJSON(value.zip),
    };
}


